module.exports = __webpack_public_path__ + "img/royal_spawning_grounds_small.38fba6f6.png";